export { default as LogoVector } from "./LogoVector";
